var exports = {
  "D": "x127c5a35--c6f32e--title",
  "q": "x127c5a35--c6f32e--load-more-button",
};

module.exports = exports;
